//
// Module for Benefit Estimate results tab
//
rs.module("ui/controls/content/benefitestimatetabs/results",

    ["controls/data/grid"],

    function (gridModule) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(fasGridLrsApi, fasPayPeriodsGridLrsApi, jsSelectors, ajaxUrls) {

            var resultsTab = $.js(jsSelectors.resultsTab);

            var benefitEstimateKeyInput = resultsTab.js(jsSelectors.benefitEstimateKeyInput);
            var fasLoadingSpinner = resultsTab.js(jsSelectors.fasLoadingSpinner);

            // On selection change, update the associated pay periods
            fasGridLrsApi.selectionChanged(function (values, rows) {
                if (_executeSelectionChanged && values.length > 0) {
                    updateFasPayPeriodsGrid(values[0]);
                }

                _executeSelectionChanged = true;
            });

            // Update the associated pay periods grid
            function updateFasPayPeriodsGrid(estimateFASSummaryKey) {
                fasLoadingSpinner.show();

                gridModule.update(
                    ajaxUrls.getFasPayPeriodsGridData,
                    {
                        benefitEstimateKey: benefitEstimateKeyInput.val(),
                        estimateFASSummaryKey: estimateFASSummaryKey
                    },
                    fasPayPeriodsGridLrsApi.agGridApi,
                    function done() {
                        fasLoadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    });